import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_CLIENT_PROCESS } from "../../config/config.json";
import { decryptStorage } from 'utils/utils';

const prepareHeaders = (includeAuthorization = true) => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    if (includeAuthorization) {
        const token = decryptStorage(localStorage.getItem("token"));
        if (token) headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_CLIENT_PROCESS,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
});

export const microserviceClientProcessAPI = createApi({
    reducerPath: 'microserviceClientProcessAPI',
    baseQuery,
    endpoints: () => ({})
});
export const microServiceClientProcessRevokeAPI = createApi({
    reducerPath: 'microServiceClientProcessRevokeAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: API_CLIENT_PROCESS,
        extraOptions: { timeout: 30000 },
        prepareHeaders: (headers) => {
            headers.set('content-type', 'application/json');
            headers.set('accept', '*/*');
            headers.set('Accept-Encoding', 'gzip, deflate, br');
            headers.set('Connection', 'keep-alive');
            const tokenRevocationGSE = decryptStorage(localStorage.getItem("tokenRevocationGSE"));
            if (tokenRevocationGSE) headers.set('Authorization', `Bearer ${tokenRevocationGSE}`);
            return headers;
        } // Por defecto, se incluye la autorización
    }),
    endpoints: () => ({})
});

export const microserviceClientProcessAPIWithoutAuth = createApi({
    reducerPath: 'microserviceClientProcessAPIWithoutAuth',
    baseQuery: fetchBaseQuery({
        baseUrl: API_CLIENT_PROCESS,
        extraOptions: { timeout: 30000 },
        prepareHeaders: prepareHeaders(false), // Sin autorización
    }),
    endpoints: () => ({})
});
